import { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { H4 } from 'components/Typography'
import { useAppSelector } from 'app/hooks'
import JobNewNote from './JobNewNote'
import JobNotesList from './JobNotesList'
import { jobInfoNotesMessages } from './messages'
import { JobNotesAddButton, JobNotesContainer, JobNotesHeader } from './styles'
import { jobInfoNotesSelector } from 'features/jobs/selectors'

function JobInfoNotes() {
  const jobNotes = useAppSelector(jobInfoNotesSelector)
  const [createNewNote, setCreateNewNote] = useState(false)

  return (
    <JobNotesContainer>
      <JobNotesHeader>
        <H4>
          <FormattedMessage {...jobInfoNotesMessages.title} />
        </H4>
        <JobNotesAddButton
          variant="secondary"
          type="button"
          onClick={() => setCreateNewNote(true)}
          disabled={createNewNote}
        >
          <FormattedMessage {...jobInfoNotesMessages.addNoteButtonLabel} />
        </JobNotesAddButton>
      </JobNotesHeader>
      {createNewNote && <JobNewNote setCreateNewNote={setCreateNewNote} />}
      <JobNotesList jobNotes={jobNotes} />
    </JobNotesContainer>
  )
}

export default JobInfoNotes
